{
  "name": "starwind",
  "version": "1.12.2",
  "description": "Add beautifully designed components to your Astro applications",
  "license": "MIT",
  "author": {
    "name": "webreaper",
    "url": "https://x.com/BowTiedWebReapr"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/starwind-ui/starwind-ui.git",
    "directory": "packages/cli"
  },
  "keywords": [
    "starwind",
    "starwind ui",
    "starwind cli",
    "astro",
    "astro component",
    "astro ui",
    "astro ui library",
    "tailwind",
    "components",
    "add component"
  ],
  "type": "module",
  "bin": {
    "starwind": "./dist/index.js"
  },
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "cli:link": "pnpm link --global",
    "cli:unlink": "pnpm rm --global starwind",
    "test": "vitest",
    "test:run": "vitest run",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc --noEmit",
    "format:check": "prettier --check \"**/*.{ts,tsx,md,json}\"",
    "format:write": "prettier --write \"**/*.{ts,tsx,md,json}\" --cache",
    "publish:beta": "pnpm publish --tag beta --access public",
    "publish:next": "pnpm publish --tag next --access public",
    "publish:release": "pnpm publish --access public"
  },
  "dependencies": {
    "@clack/prompts": "0.11.0",
    "@starwind-ui/core": "1.12.2",
    "chalk": "5.6.2",
    "commander": "14.0.2",
    "execa": "9.6.0",
    "fs-extra": "11.3.2",
    "semver": "7.7.3",
    "zod": "3.25.74"
  },
  "devDependencies": {
    "@types/fs-extra": "11.0.4",
    "@types/node": "24.10.1",
    "@types/prompts": "2.4.9",
    "@types/semver": "7.7.1",
    "tsup": "8.5.1"
  },
  "engines": {
    "node": "^20.6.0 || >=22.0.0"
  }
}
